import React, { useEffect, useContext } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import DemoDragDrop from './DemoDragDrop'
import Outputs from './Outputs'
import Cutout from './Cutout'
import { createRecaptchaElement } from '../lib/lib'

export default function DemoApp () {
    const { ut, isMobile, refineFiles } = useContext(DemoContext)
    
    useEffect(() => {
        if (!ut) {
            createRecaptchaElement()
        }
    }, [ut])

    return <div className={isMobile ? "adobe-app-demo-mobile" : "adobe-app-demo"}>
        <DemoDragDrop />
        <Cutout />
        <Outputs refineFiles={refineFiles} />
    </div>
}
